import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from './toast';

// Listens for ?payment=success/cancelled query params (set by the
// /ccbill-success and /ccbill-cancel backend redirects, plus any other
// gateway redirect that follows the same convention) and surfaces a
// theme-aware toast. After firing, strips the params from the URL so
// a refresh doesn't re-toast.
export default function PaymentRedirectToast() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const status = params.get('payment');
    if (!status) return;

    const type = params.get('type') || 'payment';
    const amount = params.get('amount');

    if (status === 'success') {
      const labels = {
        tip: amount ? `Tip sent! $${Number(amount).toFixed(2)}` : 'Tip sent!',
        subscription: 'Subscription active 🎉',
        post_unlock: 'Post unlocked',
        unlock_post: 'Post unlocked',
        post_purchase: 'Post unlocked',
        message_unlock: 'Message unlocked',
        unlock_message: 'Message unlocked',
        wallet_deposit: amount ? `Wallet topped up by $${Number(amount).toFixed(2)}` : 'Wallet topped up',
        follow: 'Follow confirmed',
      };
      toast.success(labels[type] || 'Payment successful');
    } else if (status === 'cancelled') {
      toast.info('Payment cancelled');
    }

    // Strip payment-related params and replace history so refresh is clean.
    params.delete('payment');
    params.delete('type');
    params.delete('amount');
    const next = `${location.pathname}${params.toString() ? `?${params.toString()}` : ''}${location.hash || ''}`;
    navigate(next, { replace: true });
  }, [location, navigate]);

  return null;
}
